import { showErrorNotification } from "../../global/notifications";

export default function () {
    return new Promise((resolve, reject) => {
        try {
            initializeAttachments();
            initializeAttachmentGrid();
            resolve();
        } catch (e) {
            reject(e);
        }
    })
}

const initializeAttachments = () => {
    const k_upload = $('.js-attachments')
        .kendoUpload({
            showFileList: false,
            multiple: true,
            async: {
                saveUrl: '/Operations/DownstreamContract/UploadDownstreamContractDocuments',
                autoUpload: true,
            },
            upload: function(e) {
                let contractType = $('[name="ContractType"]').val();

                if (!contractType || contractType === '') {
                    contractType = $('[name="ContractType"]')
                        .data('value')
                        .toString();
                }

                let attachmentType = '3';
                if (contractType === '1') attachmentType = $('select[name="AttachmentType"]').val();

                e.data = {
                    requestId: $('[name=Id]').val(),
                    attachmentType: attachmentType,
                    files: e.files,
                };
            },
            success: function(response) {
                console.log(response);
                if (response?.response?.Error) {
                    showErrorNotification(response.response.Error);
                }
                readGrid();
            },
            error: function(e) {
                console.error(e);
            },
            dropZone: '.dropZoneElement',
        })
        .data('kendoUpload');

    const $AttachmentType = $('select[name=AttachmentType]');
    $AttachmentType.bind('change', e => {
        k_upload.clearAllFiles();
    });
};

const initializeAttachmentGrid = () => {
    $('.js-request-attachment-grid').kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: [
            {
                field: 'category', title: 'Category', attributes: {class: ''}, width: 225
            }, {
                field: 'fString', title: 'File Name', attributes: {class: ''}
            }, {
                field: 'fExt', title: 'Extension', attributes: {class: ''}, width: 110
            }, {
                field: 'addedBy',
                title: 'Uploaded By',
                attributes: {class: ''},
                hidden: true
            }, {
                field: 'datestamp',
                title: 'Date Uploaded',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}',
                width: 145
            }, {
                field: 'attID',
                title: 'Actions',
                hidden: false,
                menu: false,
                attributes: {class: 'attID'},
                template: function (data) {
                    return `<span class="k-align-content-end" style=""><span><a data-uid-download="${data.uid}" class="k-button" href="/Download/Attachment?attid=${data.attID}"><span class="k-icon k-i-download"></span></a></span><span><a data-uid-remove="${data.uid}" data-file-id="${data.attID}" class="k-button l-delete js-delete-btn"><span class="k-icon k-i-delete"></span></a></span></span>`;
                },
                width: 120,
                filterable: false
            },
            {
                field: 'attID', hidden: true, menu: false, attributes: {class: 'attID'}
            }
        ], dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'attID', fields: {
                        attID: {editable: false, type: 'int'},
                        fString: {editable: false, type: 'string'},
                        fPath: {editable: false, type: 'string'},
                        fCat: {editable: false, type: 'string'},
                        fExt: {editable: false, type: 'string'},
                        uploadedBy: {editable: false, type: 'string'},
                        datestamp: {editable: false, type: 'date'},
                        fKeywords: {editable: false},
                        fCo: {editable: false, type: 'int'},
                        fJob: { editable: false, type: 'string' },
                        category: { editable: false }
                    }
                }
            }, transport: {
                read: {
                    url: `/Operations/DownstreamContract/GetGridAttachments`, type: 'GET', dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs.id = $('[name=Id]').val();
                        return rs;
                    }
                }
            }
        }, dataBound: function (arg) {
            attachDeleteAttachmentEvent();
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: true, columnMenu: true,
        noRecords: {
            template: 'No attachments to display.'
        }
    });
}

const attachDeleteAttachmentEvent = () => {
    const $deleteButton= $(".k-button.l-delete.js-delete-btn");
    $deleteButton.bind('click', deleteAttachment);
}

const deleteAttachment = (e) => {
    const $target = $(e.currentTarget);
    const attId = $target.data('file-id');
    $.post(`/Attachment/RemoveAttachment?attId=${attId}`, (response) => {
        if(response > 0){
            readGrid();
        }
    })
}

const readGrid = () => {
    const $attachmentsGrid = $('.js-request-attachment-grid');
    const k_attachmentsGrid = $attachmentsGrid.data('kendoGrid');

    if (k_attachmentsGrid) k_attachmentsGrid.dataSource.read();
}
